import { render, staticRenderFns } from "./StaffHistory.vue?vue&type=template&id=84934b08"
import script from "./StaffHistory.vue?vue&type=script&lang=js"
export * from "./StaffHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports